export const SITE_PREFERENCES_TOOL_TITLE = 'Site Preferences'
export const BROWSE = 'Browse'
export const UPLOAD = 'Upload'
export const DOWNLOAD_RESULTS_LINK_LABEL = 'Download Results'
export const TOOL_DESCRIPTION = `For each row of the uploaded spreadsheet, this tool will update the informed 
site Preferences values for the specified site.`
